import { OktaAuth } from '@okta/okta-auth-js';

export const authClient = new OktaAuth({
  clientId:    process.env.REACT_APP_OKTA_CLIENT_ID!,
  issuer:      process.env.REACT_APP_OKTA_ISSUER!,
  redirectUri: `${window.location.origin}/login/callback`,
  scopes:      ['openid', 'profile', 'email'],
  pkce:        true,
  tokenManager: {
    storage:             'localStorage',
    autoRenew:           false,
    autoRemove:          true,
    expireEarlySeconds:  30,
  },
  storageManager: {
    token: { storageTypes: ['localStorage'] },
    cache: { storageTypes: ['sessionStorage'] },
  },
});
